const formatNumber = (value, separator = "-", parentheses = false) => {
  value = value.replace(/\D/g, "");
  const m = value.match(/^(?:\d{0,1})(\d{3})(\d{3})(\d{4})$/);
  const formattedNum = !parentheses ? m && ["1", ...m.slice(1)].join(separator) : (
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    `1 (${m.slice(1, 2)}) ${[...m.slice(2)].join(separator)}`
  );
  return formattedNum;
};
export {
  formatNumber
};
//# sourceMappingURL=format-number.js.map
